import { CtrlType } from "@yuigoto/ctrl";

export const CardInfoChangeControl = [
    {
        name: "creditCardNumber",
        required: true,
        requiredMessage: "Preencher o nome é obrigatório",
        label: "Número: ",
        type: CtrlType.CREDIT_CARD
    },
    {
        name: "creditCardName",
        required: true,
        requiredMessage: "Preencher o nome é obrigatório",
        label:"Nome: ",
    },
    {
        name: "creditCardExpirationMonth",
        required: true,
        requiredMessage: "Preencher o nome é obrigatório",
        label: "Mês: ",
        type: CtrlType.Number,
        regexMessage: "Número do cartão inválido"
    },
    {
        name: "creditCardExpirationYear",
        required: true,
        requiredMessage: "Preencher o nome é obrigatório",
        label: "Ano: ",
        type: CtrlType.Number
    },
    {
        name: "creditCardCVV",
        required: true,
        requiredMessage: "Preencher o nome é obrigatório",
        label: "CVV: ",
        type: CtrlType.Number
    }
]